import { AddressZero } from "@ethersproject/constants";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, Redirect, Route, Switch, useLocation } from "react-router-dom";
import { useAccount, useDisconnect } from "wagmi";
import "./App.css";
import { Toaster } from "./Components/ui/toaster";

import Login from "./Components/Auth/Login";
import Org from "./Components/Auth/Org";
import OrgType from "./Components/Auth/OrgType";
import Registration from "./Components/Auth/Registration";
import User from "./Components/Auth/User";
import DocType from "./Components/Document/DocType";
import AddEditAsset from "./Components/Intervention/AddEditAsset";
import AddEditIntervention from "./Components/Intervention/AddEditIntervention";
import Asset from "./Components/Intervention/Asset";
import Entitlements from "./Components/Intervention/Entitlements";
import Intervention from "./Components/Intervention/Intervention";
import Yield from "./Components/Intervention/Yield";
import { PrivateRoute } from "./Components/PrivateRoute/PrivateRoute";
import { setAuth } from "./store/auth/authSlice";

import {
  FileProtectOutlined,
  HomeOutlined,
  LoginOutlined,
  PoweroffOutlined,
  SafetyCertificateOutlined,
  SettingOutlined,
  UnlockOutlined,
  UserAddOutlined,
} from "@ant-design/icons";
import { Layout, Menu, message, Tabs, Typography } from "antd";
import "antd/dist/antd.css";
import jwt_decode from "jwt-decode";
import ViewDocuments from "./Components/Document/ViewDocuments";
import CertificateView from "./Components/Intervention/CertificateView";
import AdminCertificateView from "./Components/Intervention/AdminCertificateView";
import ViewYields from "./Components/Intervention/viewYields";

import "@rainbow-me/rainbowkit/styles.css";

import { MethodologyPage } from "Components/Methodology/MethodologyPage";
import { useHistory } from "react-router-dom/cjs/react-router-dom";
import { isAddressesSame } from "./bc-client/BCUtil";
import ForgotPassword from "./Components/Auth/ForgotPassword";
import ResetPassword from "./Components/Auth/ResetPassword";
import ContactAdmin from "./Components/Intervention/ContactAdmin";
import ViewAssets from "./Components/Intervention/ViewAssets";
import InterventionInputs from "./Components/InterventionInput/InterventionInputs.tsx";
import { CustomConnectButton } from "./Components/Utils/CustomConnectButton";
import { authApi } from "./store/auth/authapi";
import { groupApi } from "./store/auth/groupapi";
import { orgApi } from "./store/auth/orgapi";
import { orgtypeApi } from "./store/auth/orgtypeapi";
import { userApi } from "./store/auth/userapi";
import { doctypeApi } from "./store/ds/doctypeapi";
import { documentAccessApi } from "./store/ds/documentaccessapi";
import { documentApi } from "./store/ds/documentapi";
import { assetApi } from "./store/is/assetapi";
import { assignmentApi } from "./store/is/assignmentapi";
import { entitlementCreditBundleApi } from "./store/is/entitlementCreditBundleApi";
import { finaltokApi } from "./store/is/finaltokapi";
import { setAsset, setIntervention, setYield } from "./store/is/isSlice";
import { paramsApi } from "./store/is/paramsapi";
import { projectApi } from "./store/is/projectapi";
import { transactionApi } from "./store/is/transactionapi";
import { validationApi } from "./store/is/validationapi";
import { verificationApi } from "./store/is/verificationapi";
import { yieldApi } from "./store/is/yieldapi";
import { UserGroup } from "./types/index.ts";

//notificaiton

const { Header, Content, Footer, Sider } = Layout;
const { TabPane } = Tabs;

const LogoutHandler = ({ onClearAuth, platformBase }) => {
  const ranRef = React.useRef(false);
  useEffect(() => {
    if (ranRef.current) return;
    ranRef.current = true;
    onClearAuth?.();
    const callbackUrl = `${window.location.origin}/logged-out`;
    const resolvedPlatformBase =
      platformBase || process.env.REACT_APP_PLATFORM_URL || "http://localhost:3333";
    if (resolvedPlatformBase) {
      const target = new URL("/auth/signout", resolvedPlatformBase);
      target.searchParams.set("callbackUrl", callbackUrl);
      window.location.replace(target.toString());
    } else {
      window.location.replace("/login");
    }
  }, [onClearAuth, platformBase]);
  return null;
};

const LoggedOutHandler = ({ onClearAuth }) => {
  const ranRef = React.useRef(false);
  useEffect(() => {
    if (ranRef.current) return;
    ranRef.current = true;
    onClearAuth?.();
    const qs = window.location.search || "";
    const next = `/login${qs}`;
    window.location.replace(next);
  }, [onClearAuth]);
  return null;
};

const ForwardToPlatform = () => {
  const loc = useLocation();
  const hasRedirectedRef = React.useRef(false);
  useEffect(() => {
    if (hasRedirectedRef.current) return;
    try {
      const params = new URLSearchParams(loc.search);
      const callbackUrl = params.get("callbackUrl");
      const redirectUrl = params.get("redirectUrl");
      const jwtFromStorage = localStorage.getItem("jwt");
      if (callbackUrl && jwtFromStorage) {
        hasRedirectedRef.current = true;
        const rawToken = jwtFromStorage.replace("Bearer ", "");
        const userObj = JSON.parse(localStorage.getItem("user") || "{}");
        const email = userObj?.email || userObj?.username || "";
        const platformBase =
          process.env.REACT_APP_PLATFORM_URL || "http://localhost:3333";
        const target = new URL("/auth/signin", platformBase);
        target.searchParams.set("token", rawToken);
        if (email) target.searchParams.set("email", email);
        target.searchParams.set("callbackUrl", callbackUrl);
        if (redirectUrl) {
          target.searchParams.set("redirectUrl", redirectUrl);
        }
        window.location.replace(target.toString());
      }
    } catch (_) {}
  }, [loc.search]);
  return null;
};

function App() {
  const history = useHistory();
  const dispatch = useDispatch();
  // Centralized auth/cache clear and broadcast for multi-tab
  const clearAuthAndCaches = React.useCallback(() => {
    const authObj = {
      token: "",
      userid: "",
      baddress: "",
      groups: [],
      org: {},
    };
    dispatch(setAuth(authObj));
    localStorage.removeItem("jwt");
    localStorage.removeItem("user");
    // broadcast multi-tab logout
    try { localStorage.setItem("proba:logout", String(Date.now())); } catch {}
    // remove all cache when logging out
    invalidateApiCache();
  }, [dispatch]);

  // Multi-tab logout sync
  useEffect(() => {
    let isNavigating = false;
    const onStorage = (e) => {
      if (e.key === "proba:logout" && !isNavigating) {
        isNavigating = true;
        clearAuthAndCaches();
        const qs = window.location.search || '';
        history.replace(`/login${qs}`);
      }
    };
    window.addEventListener("storage", onStorage);
    return () => window.removeEventListener("storage", onStorage);
  }, [clearAuthAndCaches, history]);

  // //notificaiton starts::
  const [initialRender, setInitialRender] = useState(true);
  let userid = useSelector((state) => state.auth.userid);
  let userBAddress = useSelector((state) => state.auth.baddress);
  const userOrgName = useSelector((state) => state.auth?.org?.name);
  const userGroupName = useSelector((state) =>
    state.auth.groups?.map((group) => group?.name)
  );
  let auth = useSelector((state) => state.auth);
  //captures Bc address when login
  const { address = "0x", isConnected } = useAccount();
  const { disconnect } = useDisconnect();

  //notificaiotn ends::
  let location = useLocation();
  const [current, setCurrent] = React.useState("");
  const [colapsed, setCollapsed] = useState(!(location.pathname === "/iv"));

  let token = useSelector((state) => state.auth.token);
  const [authReady, setAuthReady] = useState(false);

  const isProbaOperatorOrAdmin = userGroupName?.some(
    (group) => group === UserGroup.PROBA_OPERATOR || group === UserGroup.ADMIN
  );

  useEffect(() => {
    const checkTokenExpiration = () => {
      if (!token) return;

      try {
        const decoded = jwt_decode(token);
        const isExpired = decoded.exp < Date.now() / 1000;

        if (isExpired) {
          // Clear auth state
          dispatch(
            setAuth({
              token: "",
              userid: "",
              baddress: "",
              groups: [],
              org: {},
            })
          );
          localStorage.removeItem("jwt");
          localStorage.removeItem("user");
          message.error("Session expired. Please login again.");
          const qs = window.location.search || "";
          history.push(`/login${qs}`);
        }
      } catch (error) {
        console.error("Token decode error:", error);
      }
    };

    // Initial check
    checkTokenExpiration();

    // Periodic check (every minute)
    const interval = setInterval(checkTokenExpiration, 60000);
    return () => clearInterval(interval);
  }, [token, dispatch, history]);

  // 3. Token initialization / auth bootstrap effect
  useEffect(() => {
    if (authReady) return;

    if (!token) {
      const jwtFromStorage = localStorage.getItem("jwt");

      if (!jwtFromStorage) {
        setAuthReady(true);
        return;
      }

      const rawToken = jwtFromStorage.replace("Bearer ", "");

      try {
        const decoded = jwt_decode(rawToken);
        const expired = decoded.exp < Date.now() / 1000;

        if (expired) {
          dispatch(
            setAuth({
              token: "",
              userid: "",
              baddress: "",
              groups: [],
              org: {},
            })
          );
          localStorage.removeItem("jwt");
          localStorage.removeItem("user");
          setAuthReady(true);
          const qs = window.location.search || "";
          history.push(`/login${qs}`);
          return;
        }

        const userData = JSON.parse(localStorage.getItem("user"));
        dispatch(
          setAuth({
            token: rawToken,
            userid: decoded.userId,
            baddress: userData?.baddress,
            groups: userData?.group,
            org: userData?.org,
          })
        );
        setAuthReady(true);
      } catch (error) {
        console.error("Token processing error:", error);
        setAuthReady(true);
      }

      return;
    }

    setAuthReady(true);
  }, [authReady, token, dispatch, history]);

  const firstName = JSON.parse(localStorage.getItem("user"))?.fname;
  const lastName = JSON.parse(localStorage.getItem("user"))?.lname;
  const useOwnWallet = JSON.parse(localStorage.getItem("user"))?.useownwallet;

  useEffect(() => {
    if (token) {
      const timer = setTimeout(() => {
        setInitialRender(false);
      }, 1);
      return () => clearTimeout(timer);
    } else {
      setInitialRender(true);
    }
  }, [token]);

  useEffect(() => {
    if (userid === "") return;
    if (
      userBAddress === undefined ||
      userBAddress === AddressZero ||
      userBAddress === ""
    )
      return;
    if (
      isConnected &&
      useOwnWallet &&
      !isAddressesSame(address, userBAddress)
    ) {
      message.error({
        content: `This is not your registered blockchain Address. Please switch to ${userBAddress}`,
        key: "updatable",
        duration: 5,
      });
      disconnect();
    }
  }, [address, userBAddress, disconnect, isConnected, userid]);

  const allMenuItems = [
    {
      icon: <HomeOutlined />,
      key: "intervention",
      label: "GHG Project",
      privid: "l1_intervention",
      children: [
        {
          label: <Link to="/intervention/list">GHG Project</Link>,
          key: "intervention",
          privid: "l2_intervention",
        },
      ],
    },
    {
      icon: <FileProtectOutlined />,
      key: "documents",
      label: "Documents",
      privid: "l1_documents",
      children: [
        {
          label: <Link to="/documents">Documents</Link>,
          key: "documents",
          privid: "l2_documents",
        },
      ],
    },
    {
      icon: <SettingOutlined />,
      key: "configuration",
      label: "Configuration",
      privid: "l1_configuration",
      children: [
        {
          label: <Link to="/method">Methodology</Link>,
          key: "methods",
          privid: "l2_configuration_methods",
        },
        {
          label: <Link to="/doctype">Document Type</Link>,
          key: "doctype",
          privid: "l2_configuration_doctype",
        },
        isProbaOperatorOrAdmin && {
          label: (
            <Link to="/intervention_input">Intervention Input Catalog</Link>
          ),
          key: "input_cat",
          privid: "l2_configuration_doctype",
        },
      ].filter(Boolean),
    },

    {
      label: "Administration",
      icon: <UnlockOutlined />,
      key: "admin",
      privid: "l1_administration",
      children: [
        {
          label: <Link to="/user">User</Link>,
          key: "user",
          privid: "l2_administration_user",
        },
        {
          label: <Link to="/org">Organization</Link>,
          key: "org",
          privid: "l2_administration_org",
        },
        {
          label: <Link to="/orgtype">Organization Type</Link>,
          key: "orgtype",
          privid: "l2_administration_orgtype",
        },
        {
          label: <Link to="/admin/certificates">Certificates</Link>,
          key: "admin_certificates",
          privid: "l2_administration_user",
        },
      ],
    },
    {
      label: "Certificates",
      icon: <SafetyCertificateOutlined />,
      key: "certificateview",
      privid: "l1_certificatesview",
      children: [
        {
          label: <Link to="/certificateview">Credits</Link>,
          key: "certificatesview",
          privid: "l2_certificatesview",
        },
        {
          label: <Link to="/intervention/entitlements">Pre-Credits</Link>,
          key: "entitlements",
          privid: "l2_certificatesview_precredits",
        },
      ],
    },
    {
      label:
        userBAddress === undefined ||
        userBAddress === AddressZero ||
        userBAddress === "" ? (
          <></>
        ) : (
          <CustomConnectButton />
        ),
      key: "bcbutton",
      privid: "default",
      children: [],
      style: { marginLeft: "auto" },
    },
    {
      label: <span onClick={() => history.push("/login")}>Login</span>,
      icon: <LoginOutlined onClick={() => history.push("/login")} />,
      key: "login",
      privid: "na",
      children: [],
      style: { marginLeft: "auto" },
    },
    {
      label: (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            height: "60px",
            lineHeight: "20px",
          }}
        >
          <div>
            <div style={{ display: "flex", flexDirection: "column" }}>
              <Typography.Text
                style={{ color: "inherit" }}
              >{`Welcome, ${firstName} ${lastName}`}</Typography.Text>
              {userOrgName && (
                <Typography.Text
                  style={{
                    color: "inherit",
                    textAlign: "center",
                    fontWeight: "bold",
                  }}
                >
                  ({userOrgName})
                </Typography.Text>
              )}
            </div>
          </div>
        </div>
      ),
      key: "username",
      privid: "default",
      className: "user-name-text",
      style: {
        fontSize: "1rem",
        cursor: "not-allowed",
        pointerEvents: "none",
        ...(!(
          userGroupName?.includes("Certificate Access") &&
          useOwnWallet
        )
          ? { marginLeft: "auto" }
          : {}),
      },
    },
    {
      label: "Logout",
      icon: <PoweroffOutlined />,
      key: "logout",
      privid: "default",
    },
    {
      label: <span onClick={() => history.push("/register")}>Register</span>,
      icon: <UserAddOutlined onClick={() => history.push("/register")} />,
      key: "register",
      privid: "na",
      children: [],
    },
  ];

  let menuPrivIds = [];
  menuPrivIds.push("default");

  let usergroups = [];
  usergroups = useSelector((state) => state.auth.groups);
  if (usergroups && usergroups.length > 0) {
    usergroups.forEach((group) => {
      if (group) {
        group?.privileges.forEach((priv) => {
          if (priv) {
            menuPrivIds.push(priv.name);
          }
        });
      }
    });
  }

  var menuItemsToLoad = [];

  token
    ? allMenuItems.forEach((e1) =>
        menuPrivIds.forEach((e2) => {
          if (e1.privid === e2) {
            if (e1.children) {
              var childs = [];
              e1.children.forEach((c1) =>
                menuPrivIds.forEach((c2) => {
                  if (c1.privid === c2) {
                    childs.push(c1);
                  }
                })
              );
              childs = [...new Set(childs)];
              e1.children = childs;
            }
            if (
              e1.privid === "default" &&
              e1.key === "bcbutton" &&
              userGroupName?.includes("Certificate Access") &&
              useOwnWallet
            ) {
              menuItemsToLoad.push(e1);
            } else if (e1.key !== "bcbutton") {
              menuItemsToLoad.push(e1);
            }
          }
        })
      )
    : allMenuItems.forEach((e1) => {
        if (e1.privid === "na") {
          menuItemsToLoad.push(e1);
        }
      });

  //remove duplciates
  let uniqueMenuItemsToLoad = [...new Set(menuItemsToLoad)];

  // invalidates the cache of the apis
  const invalidateApiCache = () => {
    //auth
    dispatch(authApi.util.resetApiState());
    dispatch(groupApi.util.resetApiState());
    dispatch(orgApi.util.resetApiState());
    dispatch(orgtypeApi.util.resetApiState());
    dispatch(userApi.util.resetApiState());

    //ds
    dispatch(doctypeApi.util.resetApiState());
    dispatch(documentAccessApi.util.resetApiState());
    dispatch(documentApi.util.resetApiState());

    //is
    dispatch(assetApi.util.resetApiState());
    dispatch(assignmentApi.util.resetApiState());
    dispatch(projectApi.util.resetApiState());
    dispatch(paramsApi.util.resetApiState());
    dispatch(verificationApi.util.resetApiState());
    dispatch(yieldApi.util.resetApiState());
    dispatch(validationApi.util.resetApiState());
    dispatch(transactionApi.util.resetApiState());
    dispatch(finaltokApi.util.resetApiState());
    dispatch(entitlementCreditBundleApi.util.resetApiState());

    //reset Slice
    dispatch(setAsset(null));
    dispatch(setIntervention(null));
    dispatch(setYield(null));
  };

  const onClick = (e) => {
    // console.log("click ", e);
    setCurrent(e.key);
    if (e.key === "logout") {
      setCollapsed(true);
      history.push("/logout");
    }

    if (e.key === "login") {
      history.push("/login");
    }

    if (e.key === "register") {
      history.push("/register");
    }
  };

  if (!authReady) {
    return null;
  }

  return (
    <Layout
      style={{
        height: "100vh",
      }}
    >
      <Toaster />
      <Header
        style={{
          position: "fixed",
          zIndex: 1,
          width: "100%",
          backgroundColor: "#123B2E",
        }}
      >
        <div className="logo">
          <img src="/negative_logo.png" alt="logo" style={{ height: 36, display: 'inline' }} />
        </div>

        {initialRender ? (
          <Menu
            onClick={onClick}
            selectedKeys={[current]}
            theme="dark"
            mode="horizontal"
            items={uniqueMenuItemsToLoad}
            style={{ backgroundColor: "#123B2E" }}
            openKeys={[]}
          />
        ) : (
          <Menu
            onClick={onClick}
            selectedKeys={[current]}
            theme="dark"
            mode="horizontal"
            items={uniqueMenuItemsToLoad}
            style={{ backgroundColor: "#123B2E" }}
          />
        )}

        {/* {isConnected && (
          <button style={{marginTop:24}} className="button">
            Mint
         </button>
         )} */}
      </Header>

      <Layout>
        <Content
          className="site-layout"
          style={{
            padding: "0 10px",
            marginTop: 58,
            backgroundColor: location.pathname === "/" ? "#ffffff" : "#f2f4f5",
          }}
        >
          <div
            className="site-layout-background"
            style={{
              padding: 24,
              minHeight: 500,
              backgroundColor:
                location.pathname === "/" ? "#ffffff" : "#f2f4f5",
            }}
          >
            <Switch>
              <Route path="/logout">
                <LogoutHandler
                  onClearAuth={clearAuthAndCaches}
                  platformBase={process.env.REACT_APP_PLATFORM_URL}
                />
              </Route>
              <Route path="/logged-out">
                <LoggedOutHandler onClearAuth={clearAuthAndCaches} />
              </Route>
              {/* TODO: DO this in a more elegant way */}
              <Route exact path="/">
                {!token ? (
                  <Login />
                ) : (
                  <Redirect
                    to={{
                      pathname: "/login",
                      state: { from: location },
                    }}
                  />
                )}
              </Route>

              <Route path="/login">
                {!token ? (
                  <Login />
                ) : (
                  (new URLSearchParams(location.search).get('callbackUrl') || new URLSearchParams(location.search).get('redirectUrl')) ? (
                    <ForwardToPlatform />
                  ) : (
                    <Redirect
                      to={{
                        pathname: "/intervention/list",
                        state: { from: location },
                      }}
                    />
                  )
                )}
              </Route>
              <Route path="/register">
                {!token ? (
                  <Registration />
                ) : (
                  <Redirect
                    to={{
                      pathname: "/intervention",
                      state: { from: location },
                    }}
                  />
                )}
              </Route>
              <Route path="/forgot-password">
                {!token ? (
                  <ForgotPassword />
                ) : (
                  <Redirect
                    to={{
                      pathname: "/intervention/list",
                      state: { from: location },
                    }}
                  />
                )}
              </Route>
              <Route path="/reset-password/:token">
                {!token ? (
                  <ResetPassword />
                ) : (
                  <Redirect
                    to={{
                      pathname: "/intervention/list",
                      state: { from: location },
                    }}
                  />
                )}
              </Route>
              <PrivateRoute path="/user">
                <User />
              </PrivateRoute>
              <PrivateRoute path="/org">
                <Org />
              </PrivateRoute>
              <PrivateRoute path="/orgtype">
                <OrgType />
              </PrivateRoute>
              <PrivateRoute path="/admin/certificates">
                <AdminCertificateView />
              </PrivateRoute>
              <PrivateRoute path="/intervention/list">
                <Intervention />
              </PrivateRoute>
              <PrivateRoute path="/intervention/entitlements">
                <Entitlements />
              </PrivateRoute>
              <PrivateRoute path="/contact-admin">
                <ContactAdmin />
              </PrivateRoute>
              <PrivateRoute path="/documents">
                <ViewDocuments />
              </PrivateRoute>
              <PrivateRoute path="/intervention/:id">
                <AddEditIntervention />
              </PrivateRoute>
              <PrivateRoute path="/inter/yields/view">
                <ViewYields />
              </PrivateRoute>
              <PrivateRoute path="/inter/assets/view">
                <ViewAssets />
              </PrivateRoute>
              <PrivateRoute path="/asset/list">
                <Asset />
              </PrivateRoute>
              <PrivateRoute path="/asset/:id">
                <AddEditAsset />
              </PrivateRoute>
              <PrivateRoute path="/asset/yield">
                <Yield />
              </PrivateRoute>
              <PrivateRoute path="/doctype">
                <DocType />
              </PrivateRoute>
              <PrivateRoute path="/certificateview">
                <CertificateView />
              </PrivateRoute>
              {isProbaOperatorOrAdmin && (
                <>
                  <PrivateRoute path="/method">
                    <MethodologyPage />
                  </PrivateRoute>
                  <PrivateRoute path="/intervention_input">
                    <InterventionInputs />
                  </PrivateRoute>
                </>
              )}
              <Route path="*">
                <h1>404 Page not found</h1>
              </Route>
            </Switch>
          </div>
        </Content>
      </Layout>
    </Layout>
  );
}

export default App;
